import React from 'react';
import PropTypes from 'prop-types';
import './ObjectRepeat.css';

import InfoTooltip from '../../compat/InfoTooltip';

import arrowForward from '../../../../image/Icons/arrow-forward.svg';
import tick from '../../../../image/Icons/tick.svg';

/**
 * ObjectRepeat.
 * Re-usable component for product packages.
 *
 * @author  Manny
 * @param   {Boolean}     props.buyNow          Check if method is buyNow.
 * @param   {String}      props.industryKey     Name of the industry.
 * @param   {Function}    props.onSelectPackage Handles onClick for selecting a package.
 * @param   {Object}      props.packages        List of packages.
 * @param   {String}      props.product         Name of the product.
 * @returns {JSX.Element} The component markup.
 */

const ObjectRepeat = ({ buyNow, industryKey, onSelectPackage, packages, product }) => {
  if (!packages) return
  let productPackages = Object.keys(packages).map((singlePackage, index) => {
    let item = packages[singlePackage];
    let isCommercial = product === 'commercial';

    let classNames = require('classnames');
    let packageBtnClass = classNames(
      "btn",
      "package-btn",
      { "btn-width-190": !isCommercial }
    );
    let packageColumn = 'col-xs-3'
    if (singlePackage == 'lite' || singlePackage == 'cordell_estimator_platinum_lite') {
      packageColumn = 'col-xs-4 col-xs-offset-3 '
    }
    if ((buyNow && item.key === 'trial') || item.visible === false || (Object.prototype.hasOwnProperty.call(item, 'enabled') && !item.enabled) ) {
      return <div key={`trial_${item.key}_${index}`}></div>;
    } else {
      return (
        <div
          className={`${packageColumn} margin-top-20 package-box-container ${item.popular ? "best-value-card":""}`}
          id={item.key}
          key={`${item.key}_${index}`}
          style={isCommercial ? { width: '32%' } : null}
        >
          {item.popular && <div id="best-value-caption" className="best-value-tag captions"><b>BEST VALUE</b></div>}
          {item.starburst && (
            <div className='text-center'>
              <span className='popular-tag'>
                <i className='fa fa-star' aria-hidden='true'></i>
                <span> 20% Off</span>
              </span>
            </div>
          )}
          <p className='package-title'>
            {item.title == 'Residential Plus'
            ? <>{item.title}<br/><br/></>
            : item.title}
          </p>

          {item.blurb && (
            <p className='packages-panel-body'>
              <span className='white-space body'>{item.blurb}</span>
            </p>
          )}
          {item.description && (
            <p className='packages-panel-body commercial-panel-body'>
              <span className='white-space body'>{item.description}</span>
            </p>
          )}
          {item.short_description && (
            <p
              className={
                product === 'cordellEstimator'
                  ? 'package-blurb packages-panel-body cordell-estimator-panel-body'
                  : 'package-blurb packages-panel-body cordell-panel-body'
              }
            >
              <span className='white-space body'>{item.short_description}</span>
            </p>
          )}
          {item.dollars > 0 && (
            <p style={{ maxWidth: '400px', margin: '10px 0 10px' }}>
              <span className='heading2'>
                <b style={{fontFamily: 'TWK Everett, sans-serif', fontWeight: 700, fontSize: "36px", lineHeight: "32px"}}>
                  From ${item.dollars}{item.cents < 1 ? '' : '.'+item.cents}
                </b>
              </span>
              {item.key !== 'one_month' &&
                  <span className="footnote-text" style={{lineHeight: "15px", fontSize: "14px", fontWeight: 400}}>
                    /MTH
                  </span>}
            </p>
          )}
          {item.dollars === 0 && (
            <p style={{maxWidth: '200px', margin: '10px 0px', paddingLeft:'30px'}}>
              <span className='heading2'>FREE</span>
            </p>
          )}

          <p className='package-sub-text footnote-text' style={{fontSize: '11px', lineHeight: '17px', color: '#1e1405', opacity: 0.6}}>{item.sub_text_1}</p> {/* Min. cost */}
          <p className='package-sub-text footnote-text' style={{fontSize: '11px', lineHeight: '17px', color: '#1e1405', opacity: 0.6}}>{item.sub_text_2}</p> {/* over 12 months */}
          <button
            id={`btn_${item.key}`}
            type="button"
            className={`${packageBtnClass} btn-arrow-move`}
            onClick={() => onSelectPackage(industryKey, item.key) }
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '0.5rem',
              width: '100%',
              padding: '12px 24px',
            }}
          >
            {product === 'commercial' ? 'Customise Package' : 'Select Package'}
            <img src={arrowForward} alt='>' className='arrow-forward'/>
          </button>
          <hr/>
          <div className="features-list">
            {item.features?.display?.map((feature, featureKey) => {
              if (feature) {
                return (
                  <div className="features-container body flex" key={featureKey}>
                    <div>
                      <img src={tick} alt='yes' className='margin-right-5 tick-margin' />
                    </div>
                    <div className="column title-column">
                      {feature.title}
                    </div>
                    <div className="column text-right">
                    {(feature.description || feature.descriptionHeader) &&
                      <InfoTooltip text={feature.description || ''} title={feature.descriptionHeader || ''}>
                        <span style={{
                          alignItems: "center",
                          border: "1px solid #79848b",
                          borderRadius: "50%",
                          cursor: "pointer",
                          display: "flex",
                          fontFamily: "TWK Everett, sans-serif",
                          fontSize: "11px",
                          height: "15px",
                          justifyContent: "center",
                          marginTop: "5px",
                          width: "15px"
                        }}>
                          i
                        </span>
                      </InfoTooltip>
                      }
                    </div>
                  </div>
                );
              }
            })}
          </div>
        </div>
      );
    }
  });
  return (
    <div key='product-packages-key'>
      <div className={
          product === 'commercial' ? '' :
          product === 'cordell' || product === 'cordellEstimator' ? 'd-none' :
          'col-xs-3'
      }></div>
      {productPackages}
    </div>
  );
};

ObjectRepeat.propTypes = {
  buyNow: PropTypes.bool,
  industryKey: PropTypes.string,
  onSelectPackage: PropTypes.func.isRequired,
  packages: PropTypes.object.isRequired,
  product: PropTypes.string.isRequired
};

export default ObjectRepeat;
